import { GlobalStyles as LuxGlobalStyles, Global, css } from '@lux/ds';

const GlobalStyles: React.FC = () => {
  return (
    <>
      <Global
        styles={css`
          body {
            position: relative;
            display: flex;
            margin: 0;
            overflow: hidden;
            height: 100vh;

            & > main {
              position: relative;
              display: flex;
              flex-direction: column;
              flex: 1;
              overflow: hidden;

              & > header {
                background-color: #fff;
                height: 64px;
                top: 0;
                width: 100%;
                overflow: hidden;
                box-shadow: 0px 2px 4px rgba(68, 68, 66, 0.05);
                z-index: 5;
              }
            }

            & > nav {
              position: relative;
              min-width: 60px;
              height: 100vh;
              background-color: #fff;
              overflow: visible;
              box-sizing: unset;

              * {
                box-sizing: unset;
              }
            }
          }

          #root {
            position: relative;
            overflow: auto;
            flex: 1;
          }
        `}
      />
      <LuxGlobalStyles />
    </>
  );
};

export default GlobalStyles;
